import { AppState } from '@redux/types';

import { Billing } from '@shared/interfaces/billing';

export function _getCustomerBillingInfo(state: AppState): Billing {
  return state.billing;
}
